// import { toast } from "react-toastify"
import { toast } from "sonner"

const checkResponse = (data) => {
    if (data && data?.setting.success == 1) {
        return data.data
    } else {
        let err = data?.setting.message || "Operation failed. Try again..."
        toast.error(err)
        throw new Error(err)
    }
}

export default checkResponse